import React, { Component } from "react";
import { Helmet } from "react-helmet";
import FaqData from "assets/data/glampartnerFaq.json";

class GlampartnerFaq extends Component {

  constructor(props) {
    super(props);
  }
  renderFaqData = () => {
    return FaqData.map((item, key) => {
      return (
        <div key={key} className={"faq_glampartners pb-4"}>
          <h2>{item.name}</h2>

          <div className={"level-2 p-3 p-xl-5 category"}>
            {(() => {
              return item.questions.map((question, qKey) => {
                return (
                  <div key={qKey} className={"pb-4"}>
                    <h4 id={question.slug}>{question.title}</h4>
                    <p dangerouslySetInnerHTML={{ __html: question.text }} />
                  </div>
                );
              });
            })()}
          </div>
        </div>
      );
    });
  }

  getUrlKey=()=>{
    let idToScroll = this.props.location;
    console.log(idToScroll.hash.replace('#','' ))
    idToScroll.hash !==''  &&  this.scrollTo(idToScroll.hash.replace('#','' ) );      
 }

 scrollTo=(id)=>{
   document.getElementById('gb-contents').scrollTo(0, document.getElementById(id).offsetTop);
 }

 componentDidMount(){
  this.getUrlKey();
 }

  render() {
    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Minha Glambox : FAQ</title>
        </Helmet>
        {this.renderFaqData()}
      </div>
    );
  }
}

export { GlampartnerFaq }